import Spacer from './spacer';

function ApiErrorMessage(props) {
  const { apiError } = props;
  return (
    <>
      {apiError?.length > 0
      && (
      <div>
        <p className="w-4/5 text-sm inline-block p-1 pr-3 pl-3 bg-red-700 mt-2 text-white rounded-lg border-white border">{apiError}</p>
        <Spacer />
      </div>
      )}
    </>
  );
}

export default ApiErrorMessage;
